import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "@/store";

export const useDepositBatchesFilterState = () => {
  const filterState = useSelector(
    (state: ApplicationState) => state.filterDepositBatches,
  );
  return useMemo(() => filterState, [filterState]);
};
